import * as React from "react";
import { SVGProps } from "react";

const Gas = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333 373" {...props}>
    <path
      fill="none"
      stroke="#01e397"
      strokeMiterlimit={10}
      strokeWidth={16.27}
      d="m325.74 61.75-158.8 59.1v240.6l-158.81-57V70.05l167.5-61.4 149.31 53.4.8 241.8-159-58.9"
    />
  </svg>
);

export default Gas;
